<template>
  <div id="details">
    <van-index-bar :index-list="indexList">
      <!-- 头部返回 -->
      <!-- <header>
        <div class="header">
          <div class="bbcc" >
            <van-icon name="arrow-left" class="i" @click="bbcak"/>
            <span>商品详情</span>
          </div>
        </div>
      </header> -->
       <!-- 头部 -->
    <hearderCommon :text="text"></hearderCommon>

      <van-index-anchor index="商品"></van-index-anchor>
      <!-- 轮播图 -->
      <div class="details-header">
        <van-swipe @change="onChange">
          <van-swipe-item>
            <img :src="goods.picUrl"  alt style="height:100%;object-fit: cover;width:100%" />
          </van-swipe-item>
          <!-- <div class="custom-indicator" slot="indicator">{{ current + 1 }}/4</div> -->
        </van-swipe>
      </div>
      <!-- 商品详细信息 -->
      <div class="details">
        <van-panel :title="goods.goodsName" :desc="goods.remark"></van-panel>
        <van-sticky :offset-top="39" @scroll="scroll">
          <div class="standard">
            <div class="size" @click="chose(i.skuId)" v-for="i in goods.children" :key="i.skuId">
              <div class="size-left"></div>
              <div class="size-right"></div>
              <div
                class="size-top"
                :class="i.skuId == skuId? 'active' : ''"
              >￥{{i.salePrice}}</div>
              <div class="size-buttom" :class="i.skuId == skuId? 'active' : ''">
                <p class="size-buttom-p-top" v-if="i.saleRatio != 1 || i.goodsUnitLabel != i.saleUnitLabel">每{{i.saleUnitLabel}}({{i.saleRatio}}{{i.goodsUnitLabel}})</p>
                  <p class="size-buttom-p-top" v-if="i.saleRatio == 1 && i.goodsUnitLabel == i.saleUnitLabel">每{{i.saleUnitLabel}}</p>
                <p class="size-buttom-p-buttom">￥{{(i.salePrice/i.saleRatio).toFixed(2)}}/{{i.goodsUnitLabel}}</p>
              </div>
            </div>
          </div>
        </van-sticky>
      </div>
      <div class="detailsInfor van-row-one">
        <!-- 商品配置信息 -->
        <van-index-anchor index="详情"></van-index-anchor>
        <!-- <van-row>
          <van-col span="3">领卷</van-col>
        <van-col span="18" class="detailsInfor-col kkk">-->
        <!-- 优惠卷 -->
        <!-- <div class="detailsCoupon">
              <div class="detailsCoupon-left">满1000减200</div>
              <div class="detailsCoupon-right">领</div>
              <div class="detailsCoupon-top"></div>
              <div class="detailsCoupon-buttom"></div>
            </div>
            <div class="detailsCoupon">
              <div class="detailsCoupon-left">满1000减200</div>
              <div class="detailsCoupon-right">领</div>
              <div class="detailsCoupon-top"></div>
              <div class="detailsCoupon-buttom"></div>
            </div>
          </van-col>
          <van-col span="2">更多</van-col>
        </van-row>-->
        <van-row class="detailsInfor-row">
          <van-col span="3">配置</van-col>
          <van-col span="21" class="detailsInfor-col">次日达</van-col>
        </van-row>
        <van-row class="detailsInfor-row">
          <van-col span="3">服务</van-col>
          <van-col span="21" class="detailsInfor-col">田野专送</van-col>
        </van-row>
      </div>
      <!-- 商品详情 -->
      <div class="details-pin detailsInfor" v-if="goods.detailsPicUrl">
        <!-- <p class="details-pin-p">商品详情</p>
        <van-row class="detailsInfor-row">
          <van-col span="3">品牌</van-col>
          <van-col span="21" class="detailsInfor-col">自营</van-col>
        </van-row>
        <van-row class="detailsInfor-row">
          <van-col span="3">产地</van-col>
          <van-col span="21" class="detailsInfor-col">中国</van-col>
        </van-row>
        <van-row class="detailsInfor-row">
          <van-col span="5">存储条件</van-col>
          <van-col span="17" class="detailsInfor-col">常温</van-col>
        </van-row>-->
        <img :src="goods.detailsPicUrl" alt class="re-img" />
      </div>
      <!-- 文本介绍 -->
      <div class="details-text" v-html="goods.details"></div>
    </van-index-bar>
    <!-- 底部 -->
    <van-goods-action safe-area-inset-bottom >
      <van-goods-action-icon icon="search" text="搜索" @click="goSearch" />
      <van-goods-action-icon icon="cart-o" text="购物车" :info="count" @click="goCart" />
      <van-button
        type="primary"
        size="large"
        color="linear-gradient(to right, #ACDB56,#74B42B)"
        @click="addCart(goods)"
        v-if="!GoodsDto.orderQty"
      >加入购物车</van-button>
      <div  v-if="GoodsDto.orderQty" class="stepper_mix">
      <van-stepper
        v-model="GoodsDto.orderQty"
        @overlimit="addGoodsL(goods)"
        async-change
        button-size="30px"
        min="0"
        @change="changgeGoods"
        @minus="removeGoods(goods)"
        @plus="addGoods(goods)"
        @focus="revision"
        @blur="refresh"
      />
      </div>
    </van-goods-action>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";

export default {
  watch: {
    skuId(val) {
      this.GoodsDto = this.goods.children.find(item => item.skuId == val);
    }
  },
  async created() {
    // 获取商品Id
    // 获取id
    this.goodsId = this.$route.query.goodsId;
    this.customerId = localStorage.getItem("customerId");
    // 获取商品详情
    this.$axios
      .get(
        `/trade/tradeOrder/goods/price/${this.goodsId}?customerId=${this.customerId}`
      )
      .then(res => {
        if(res.data.data != null ){
          this.goods = res.data.data;
          this.skuId = this.goods.children[0].skuId
        }
      })
      .catch(() => {
      });
    // 获取购物车数量
    this.getCount();
  },
  data() {
    return {
      current: 0, //轮播图
      goodsId: "", // 商品ID
      goods: {}, // 商品详情
      indexList: ["商品", "详情"], //导航
      goodNum: 0, // 商品数量
      showStepper: false, //进步器显示
      GoodsDto: {}, //上传商品
      count: "", //购物车数量
      customerId: "", //客户ID
      skuId: "", //规格ID
      state: 0,
      text:"商品详情"
    };
  },
  methods: {
    // 轮播图
    onChange(index) {
      this.current = index;
    },
    // 添加商品
    addGood() {
      this.GoodsDto.customerId = this.customerId;
      if (this.state == 0) {
        this.$axios.post("/trade/tradeCart/save", this.GoodsDto).then(res => {
          this.state = 1;
          if (res.data.code != 0) {
            return;
          }
          this.getCount();
        });
      }
    },
    // 选择规格
    chose(id) {
      this.skuId = id;
    },
    // 滚动事件
    scroll(scrollTop) {
      scrollTop;
    },
    bbcak() {
      window.history.back();
    },
    // 去搜索页
    goSearch() {
      this.$router.push("/search");
      // 还需要存储地址
    },
    // 去购物车
    goCart() {
      this.$router.push("/cart");
    },
    // 点击加入购物车
    addCart() {
      if (!this.skuId) {
        return this.$toast("请选择商品规格");
      }
      this.GoodsDto.orderQty = 1
      this.addGood();
    },
    // 点击-显示加入购物车
    addGoodsL(Goods) {
      this.state = 0;
      this.GoodsDto.orderQty = 0;
      this.addGood(Goods);
    },
    // 减少商品
    removeGoods(Goods) {
      this.state = 0;
      this.addGood(Goods);
    },
    // 增加商品
    addGoods(Goods) {
      this.state = 0;
      this.addGood(Goods);
    },
    // 输入数量
    changgeGoods() {
      this.state = 1;
      this.addGood(this.GoodsDto);
    },
    refresh() {
      this.state = 0;
      this.addGood(this.GoodsDto);
    },
    // 获取购物车总数
    getCount() {
      this.$axios
        .get(`/trade/tradeCart/count?customerId=${this.customerId}`)
        .then(res => {
          this.count = res.data.data;
          this.$emit("count", this.count);
        });
    },
    revision() {
      this.state = 0;
    }
  },
  components: {
    hearderCommon
  }
};
</script>

<style scoped>
.active {
  background: rgba(248, 231, 28, 1) !important;
}
#details {
  padding-bottom: 50px;
  position: relative;
}
.details-header {
  z-index: 888;
}
header {
  width: 100%;
  height: 40px;
  position: fixed;
  background-color: rgba(237, 237, 237, 1);
  z-index: 2;
}
.bbcc {
  position: absolute;
  z-index: 999;
}
.header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  /* z-index: 1; */
  color: rgba(102, 102, 102, 1);
  position: fixed;
  width: 100%;
  padding-left: 30px;
  background: rgba(242, 242, 242, 1);
}
.details-header {
  padding-top: 40px;
}
.i {
  position: absolute;
  top: 13px;
  left: -20px;
}
#details >>> .van-swipe {
  height: 400px;
}
.custom-indicator {
  position: absolute;
  bottom: 1%;
  right: 5%;
  background: rgba(247, 247, 247, 1);
  padding: 1px 10px;
  border-radius: 10px;
}
.van-cell__title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 22px;
}
.standard {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
  /* height: 300px; */
  padding-left: 16px;
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
}
.van-sticky {
  padding-left: 16px;
}
.size {
  position: relative;
  margin-right: 5px;
}
.size-left,
.size-right {
  width: 10px;
  height: 10px;
  background-color: #fff;
  position: absolute;
  border-radius: 50%;
  top: 28px;
  left: -5%;
}
.size-right {
  left: 95%;
}
.size-top,
.size-buttom {
  width: 100px;
  background: rgba(247, 247, 247, 1);
  /* background: pink; */
  text-align: center;
  border-radius: 5px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 166, 35, 1);
  line-height: 30px;
  padding: 1px;
}
.size-top {
  border-bottom: 2px dashed #fff;
}
.size-buttom-p-top,
.size-buttom-p-buttom {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 27px;
  /* padding: 5px; */
}
.size-buttom-p-buttom {
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  line-height: 12px;
  padding-bottom: 5px;
}
.size-buttom-p-top {
  padding-top: 2px;
}
#details >>> .van-index-bar__sidebar {
  position: fixed;
  top: 1.4%;
  left: -50%;
}
#details >>> .van-index-bar__index:nth-child(1),
#details >>> .van-index-bar__index:nth-child(2) {
  font-size: 40px;
  position: absolute;
  left: 55%;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 25px;
  z-index: 999;
}
#details >>> .van-index-bar__index:nth-child(2) {
  font-size: 40px;
  position: absolute;
  left: 70%;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 25px;
}
#details >>> .van-index-anchor,
#details >>> .van-index-anchor--sticky,
#details >>> .van-hairline--bottom {
  display: none;
}
div[style="height: 50px;"] {
  display: none;
}
.detailsInfor {
  margin-top: 5px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  padding: 8px 0;
}
.detailsInfor {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.detailsInfor-col {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
}
.kkk {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.detailsInfor-row {
  margin-top: 10px;
  padding-left: 20px;
}
.detailsCoupon {
  position: relative;
  box-sizing: border-box;
  margin-right: 5px;
}
.detailsCoupon-left {
  width: 84px;
  line-height: 16px;
  border: 1px dashed #74b42b;
  border-right: 0px;
  display: inline-block;
  margin-right: 10px;
  text-align: center;
}
.detailsCoupon-right {
  width: 23px;
  line-height: 16px;
  border: 1px dashed #74b42b;
  border-left: 0px;
  display: inline-block;
  text-align: center;
}
.detailsCoupon-top {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border-color: pink;
  border: 1px dashed #74b42b;
  position: absolute;
  top: -26%;
  left: 71%;
}
.detailsCoupon-buttom {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border-color: pink;
  border: 1px dashed #74b42b;
  position: absolute;
  bottom: -24%;
  left: 71%;
}
.van-row-one {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  margin-top: 5px;
  margin-bottom: 5px;
}
.details-pin-p {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.details-text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  padding: 16px 0;
}
.stepper_mix{
  width: 100%;
  height: 100%;
}
.van-stepper {
  width: 100%;
  background: rgba(237, 237, 237, 1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  /* line-height: 50px; */
}
#details >>> .van-stepper__minus,
#details >>> .van-stepper__minus--disabled,
#details >>> .van-stepper__plus {
  width: 40%;
  color: #74b42b;
  height: 100%;
  font-weight: 700;
  background: rgba(237, 237, 237, 1);
  font-size: 18px;
}
#details >>> .van-stepper__input {
  width: 18%;
  background: rgba(237, 237, 237, 1);
  font-size: 18px;
  line-height: 28px;
}
.re-img {
  width: 100%;
}
.standard {
  padding: 6px 0 6px 20px;
}
.van-cell:not(:last-child)::after {
  border: 0px;
}
.van-icon-arrow-left {
  top: 12px !important;
}
</style>